module.exports = "<svg viewBox=\"0 0 9 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.357 1.912H6.92L3.413 14.658H4.5a.64.64 0 0 1 .643.637.64.64 0 0 1-.643.637H.643A.64.64 0 0 1 0 15.295a.64.64 0 0 1 .643-.637H2.08L5.587 1.912H4.5a.64.64 0 0 1-.643-.638A.64.64 0 0 1 4.5.637h3.857A.64.64 0 0 1 9 1.274a.64.64 0 0 1-.643.638z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/playbook/components/Editor/plugins/blockStyles/italic.svg
// module id = WN26
// module chunks = 89